import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import './index.css';
//  import registerServiceWorker from './serviceWorker';
// import { TestSwiper } from './com/sixdee/test/testheader/textswiper/testswiper';

ReactDOM.render(
  <App />,
  document.getElementById('root') as HTMLElement
);
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx